var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8.66667L12.2178 7.76892C11.8968 7.12679 11.7362 6.80573 11.4967 6.57116C11.285 6.36373 11.0297 6.20597 10.7494 6.10931C10.4325 6 10.0736 6 9.35567 6H8.00004C7.38006 6 7.07007 6 6.81574 6.06815C6.12555 6.25308 5.58646 6.79218 5.40152 7.48236C5.33337 7.7367 5.33337 8.04669 5.33337 8.66667V8.66667",
    stroke: "#3B5A6F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 8.66602H15.4667C16.5868 8.66602 17.1469 8.66602 17.5747 8.884C17.951 9.07575 18.257 9.38171 18.4487 9.75803C18.6667 10.1859 18.6667 10.7459 18.6667 11.866V14.7993C18.6667 15.9195 18.6667 16.4795 18.4487 16.9073C18.257 17.2837 17.951 17.5896 17.5747 17.7814C17.1469 17.9993 16.5868 17.9993 15.4667 17.9993H8.53337C7.41327 17.9993 6.85322 17.9993 6.42539 17.7814C6.04907 17.5896 5.74311 17.2837 5.55136 16.9073C5.33337 16.4795 5.33337 15.9195 5.33337 14.7993V8.66602Z",
    stroke: "#6162C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.2d0365713db048182b02bf4c727b21e7.svg";
export { ForwardRef as ReactComponent };